module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c2/btn_3_pc_d42e4328d82bc28014285b7942511cd0.png";